import React, { PureComponent } from 'react';
import './styles.scss';

class InfoAdvice extends PureComponent {
    state = {};

    render() {
        const { className, children } = this.props;
        return <div className={`fm-advice fm-advice-info ${className}`}>{children}</div>;
    }
}

export default InfoAdvice;
